import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { openUserProfile } from 'features/users/openUserProfile';

/**
 * /:team/activity/users/:distinctId — the old full-page profile. Old links,
 * bookmarks and Lucid's "open full view" land on the Users list with that
 * user's drawer open.
 */
export default function UserProfileRoute() {
  const { team, distinctId } = useParams();
  useEffect(() => { if (distinctId) openUserProfile(decodeURIComponent(distinctId)); }, [distinctId]);
  return <Navigate to={`/${encodeURIComponent(decodeURIComponent(team || ''))}/activity/users`} replace />;
}
